import type { CustomItems } from 'sendbird-calls';

// Keys the host writes and the guest reads on the Sendbird room's custom items
// to broadcast the recording lifecycle in real time. Kept in one place so the
// write side (group-call) and read side (join) can't drift via a typo.
export const RECORDING_STARTED_AT_KEY = 'recordingStartedAt';
export const RECORDING_STOPPED_AT_KEY = 'recordingStoppedAt';

export interface RecordingState {
  isRecording: boolean;
  startedAt?: number;
  stoppedAt?: number;
}

// Derives recording state from a room's custom items. Returns validated numeric
// timestamps so callers never flag "recording" with an unseedable (NaN) timer.
export const getRecordingStateFromCustomItems = (customItems?: CustomItems): RecordingState => {
  const parsedStart = parseInt(customItems?.[RECORDING_STARTED_AT_KEY] ?? '', 10);
  const parsedStop = parseInt(customItems?.[RECORDING_STOPPED_AT_KEY] ?? '', 10);
  const startedAt = Number.isFinite(parsedStart) ? parsedStart : undefined;
  const stoppedAt = Number.isFinite(parsedStop) ? parsedStop : undefined;

  return {
    isRecording: startedAt !== undefined && stoppedAt === undefined,
    startedAt,
    stoppedAt,
  };
};
